import {MainVideoState} from "../definitions/MainVideoState";

export const startedLoadingAssets = (state: MainVideoState) => {
    state.projectState.assets = [];
};
